// extracted by mini-css-extract-plugin
module.exports = {"shift":"_89i2Sc0z46Bn-OT-OSS7h","layer":"_2ymjQrNyWk5C25VGtmLxcX","relativeSp":"_1Ipjeh78mL7aoUKdp7f0ss"};